// DRE Gerencial (Gestão Orçamentária): consolidador somente leitura de todos os módulos de
// Faturamento, Custos/Despesas e Resultado — nunca tem formulário próprio, todo valor vem
// agregado dos módulos de origem (ver backend/services/dre_gerencial_svc.py).
// Espelha backend/config.py ROLES_DRE_GERENCIAL — mantenha os dois em sincronia.
export const ROLES_DRE_GERENCIAL = ["admin", "EXECUTIVA", "GESTOR_ESTRATEGICO"];
